import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Upload as UploadAntd,
  Image,
  DatePicker,
  Checkbox,
  Space,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import Noimage from "../assets/images/noimage_newww.png";
import * as XLSX from "xlsx";
import moment from "moment";
import apiPath from "../constants/apiPath";
import axios from "axios";
import { ExclamationCircleOutlined, FilterFilled, UploadOutlined,EyeOutlined } from "@ant-design/icons";
import PhoneinputField from "../components/PhoneInputField";
import lang from "../helper/lang";
import SingleImageUpload from "../components/SingleImageUpload";
import MultipleImageUpload  from "../components/MultipleImageUpload";
import notfound from "../assets/images/not_found.png";

const { RangePicker } = DatePicker;

const Search = Input.Search;
// Uploads now go through the backend (POST /admin/media/upload), which
// holds the real AWS credentials server-side and never exposes them. This
// used to upload straight to S3 from the browser with a hardcoded access
// key + secret baked into this file — visible to anyone via view-source on
// the deployed site, no login required. See MediaUploadController.ts.

let baseURL = apiPath.teamManager;

// Permission helper aligned with TeamManager
const getPermissionByName = (moduleName) => {
  try {
    const user = JSON.parse(localStorage.getItem("admin_userProfile") || "{}");
    if (user.type === "Admin") {
      return { view: true, add: true, edit: true, delete: true };
    }
    // Case/whitespace-insensitive match — see BlogTabs.js's identical fix.
    const normalizedTarget = String(moduleName || "").trim().toLowerCase();
    const permissions = user?.roleId?.permission || [];
    return (
      permissions.find(
        (p) => String(p?.name || "").trim().toLowerCase() === normalizedTarget
      ) || {}
    );
  } catch {
    return {};
  }
};

function RoleManager() {  
  const roleManagerPermission = getPermissionByName("roleManager");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [listExport, setListExport] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [filter, setFilter] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] = useState(false);
  const [file, setFile] = useState([]);
  const [permissionsData, setPermissionsData] = useState([]);
  const [callApi,setCallApi] = useState(false);
// Sample function to handle permission changes
const handlePermissionChange = async (key, permName, permType, value) => {
    try {
        await updatePermissionsAPI(key, permName, permType, value);
        fetchData(pagination);
      const updatedData = permissionsData.map((item) =>
        item._id === key
          ? {
              ...item,
              permission: item.permission.map((perm) =>
                perm.name === permName ? { ...perm, [permType]: value } : perm
              ),
            }
          : item
      );
  
      setPermissionsData(updatedData);
      fetchData(pagination); // Update UI only on success
    } catch (error) {
      console.error("Error updating permissions:", error);
    }
  };
  
  
  // Example API function
  const updatePermissionsAPI = async (key, permName, permType, value) => {
    try {
      request({
        method: "PUT",
        url: `${baseURL}/update-permissions/${key}?moduleKey=${permName}&statusKey=${permType}&value=${value}`,
      })
      console.log("Permission updated successfully",value);
      setViewData()
    } catch (error) {
      console.error("API error:", error);
    }
  };
  const getPermissionColumns = (data) => {
    const permissionNames = [...new Set(data.flatMap((item) => item.permission.map((perm) => perm.name)))];
  
    return permissionNames.map((permName) => ({
      title: permName,
      dataIndex: "permission",
      key: permName,
      render: (_, record) => {
        const permission = record.permission.find((p) => p.name === permName) || {};
  
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {["view", "add", "edit", "delete"].map((permType) => {
              const currentValue = !!permission?.[permType]; // Get current value
  
              return (
                <Checkbox
                  key={permType}
                  checked={currentValue} // Ensure checkbox reflects correct state
                  disabled={!roleManagerPermission.edit}
                  onChange={() => {
                    // Toggle once
                    handlePermissionChange(record._id, permName, permType, !currentValue);
                   // Delay of 100ms to simulate double click
                  }}
                >
                  {permType.charAt(0).toUpperCase() + permType.slice(1)}
                </Checkbox>
              );
            })}
          </div>
        );
      },
    }));
  };
  
  const columns = [
    {
      title: "Role Name",
      render: (_, { name, userName }) => {
        return <div>{name ? name : userName}</div>;
      },
    },  
    ...getPermissionColumns(list),

    {
      title: "STATUS",
      key: "isActive",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "InActive",
          value: false,
        },
      ],
      onFilter: (value, record) => record.isActive === value,
      // filtered: true,
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (_, { is_deleted, isActive, _id }) => {
        let color = is_deleted ? "red" : isActive ? "green" : "red";
        return (
          <Tag
            onClick={(e) => (!is_deleted ? showConfirm(_id) : null)}
            color={color}
            key={isActive}
          >
            {is_deleted ? "DELETED" : isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
    {
      title: "Registartion date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <>
            <div className="cta_wrap">
              {roleManagerPermission.edit && (
                <Button
                  title="Edit"
                  onClick={() => {
                    record?.image && setFile([record.image]);
                    console.log(record, "record>>>>>>>>>>>>>>>>>>>>>>>");
                    setSelected(record);
                    setVisible(true);
                  }}
                >
                  <i class="fa fa-light fa-pen"></i>
                </Button>
              )}
              {/* <Button
                title="View Listings"
                onClick={(e) => {
                  navigate("/view-user-list/" + record._id);
                  // setViewData(record);
                }}
              >
                <i class="fas fa-list"></i>
              </Button> */}
            </div>
          </>
        );
      },
    },
  ];

  const uploadFileToS3 = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await axios.post(`${apiPath.baseURL}admin/media/upload`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      return { Location: res.data?.data?.url };
    } catch (err) {
      throw err;
    }
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file);
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  // Redirect if user lacks view permission
  useEffect(() => {
    if (!roleManagerPermission?.view) {
      navigate("/dashboard");
    }
  }, [roleManagerPermission?.view]);

//   const deleteAccount = (record) => {
//     // alert(record._id)
//     request({
//       url: `${baseURL}/delete-account/${record ? record._id : ""}`,
//       method: "PUT",
//       onSuccess: (data) => {
//         console.log(data, "data");
//         setRefresh(!refresh);
//         setLoading(false);
//       },
//       onError: (error) => {
//         console.log(error);
//         ShowToast(error, Severty.ERROR);
//       },
//     });
//   };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/role-status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate,callApi]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-user/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    request({
      url: `${baseURL}/roleList?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPermissionsData(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };


  return (
    <>
      <div className="tabled">
        <Row>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Role And Permission Management"
              extra={
                <Space wrap size={[10, 10]} align="center" className="gfx-toolbar">
                  <Search
                    size="large"
                    placeholder="Search by Role Name"
                    onChange={onSearch}
                    title="Search by Name"
                    value={searchText}
                    onPressEnter={onSearch}
                    allowClear
                  />

                  <RangePicker onChange={handleChangeDate} />
                  {/* <Button
                    type="primary"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button> */}
                  {roleManagerPermission.add && (
                    <Button
                      type="primary"
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      Add New Role
                    </Button>
                  )}
                </Space>
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination?.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {
        visible && (
          <AddFrom
            file={file}
            setFile={setFile}
            handleChangeImage={handleChangeImage}
            show={visible}
            hide={() => {
              setSelected();
              setVisible(false);
              setSearchText("");
            }}
            data={selected}
            refresh={() => setRefresh((prev) => !prev)}
          />
        )
      }

      {
        provideSession && (
          <ChangePassword
            show={provideSession}
            hide={() => {
              setSelected();
              setProvideSession(false);
              setSearchText("");
            }}
            data={selected}
            refresh={() => setRefresh((prev) => !prev)}
          />
        )
      }

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>
    </>
  );
}

const AddFrom = ({
  show,
  hide,
  data,
  refresh,
  handleChangeImage,
  file,
  setFile,
}) => {
  const [mobileNumber, setMobileNumber] = useState({
    mobile_number: "",
    country_code: "",
  });
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState();
  const [images, setImages] = useState();
  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];

  const handleImage = (data) => {
    data.length > 0 ? setImage(data?.[0]?.url) : setImage("");
  };

  const handleImages = (newImages) => {
    setImages(newImages); // Appends instead of replacing
  };

  const handleChange = (value, data) => {
    var country_code = data.dialCode;
    setMobileNumber({
      country_code: country_code,
      mobile_number: value.slice(data.dialCode.length),
    });
  };

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({
      ...data
    });

    setMobileNumber({
      country_code: data.countryCode,
      mobile_number: data.mobileNumber,
    });
    setImage(data?.profilePic);
    setImages(data?.images);
  }, [data]);

  const onCreate = (values) => {
    const {  name }= values;
 

    // setLoading(true);
    const payload = {};
    payload.name = name;
    console.log(payload);

    request({
      url: `${data ? `${baseURL}/edit-role/${data._id}` : `${baseURL}/add-role`
        }`,
      method: `${data ? "PUT" : "POST"}`,
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          setFile([]);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });

  };

  return (
    <Modal
      open={show}
      title={`${data ? "Edit Role" : "Add New Role"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row>
          <Col span={24} sm={24}>
            <Form.Item
              label="Role Name"
              name="name"
              rules={[
                { required: true, message: "Please input the name!" },
                {
                  pattern: new RegExp(/^[a-zA-Z ]*$/),
                  message: "Only Alphabetic Characters Allowed",
                },
                {
                  max: 50,
                  message: "Name cannot exceed 50 characters",
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input placeholder="Enter Role Name" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const onCreate = (values) => {
    setLoading(true);
    request({
      url: `${baseURL}/reset-password/${data._id}`,
      method: `PUT`,
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        // console.log(error.response.data, "Error")
        setLoading(false);
      },
      // onErrorSubmit: (data) => {
      //   console.log(data)
      // }
    });
    // console.log(values)
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Change password" : "Create a new User"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label="New Password"
              name="new_password"
              hasFeedback
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one number, and one lowercase letter!",
                },
                {
                  max: 100,
                  message: "Title cannot exceed 100 characters",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["new_password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default RoleManager;
